
































import { jumpToUrl } from '@/utils/jump-to-url/index'
import { useWindowEvent } from '@/use'
import { useMenuList } from '../use/use-menu-list'
import { useAuth } from '@/use/biz/use-auth'
import * as PRIVILEGE from '@shared/constants/privilege'
import Icon from '@/components/icon.vue'
import { FlatMenuObject, FormatedMenuItemType, Privilege, UserSetting, SiteItem } from '../../types'
import SidebarItem from './sidebar-item.vue'
import SubMenu from './components/sub-menu.vue'
import BasicMenuItem from './components/basic-menu-item.vue'
import MenuContent from './components/menu-content.vue'
import 'amumu-ui/src/theme/src/index.scss'

import { computed, defineComponent, ref, reactive, toRefs } from '@vue/composition-api'
import { isSameUrlPath } from '@/utils'
import { HOSTS } from '@/constants/environment'

const useActiveIds = (flatMenuObject: FlatMenuObject) => {
  let activeIds = ref<string[]>([])

  const setActiveIds = () => {
    const actives = Object.values(flatMenuObject).filter((menuItem) => {
      const { highlightUrls } = menuItem as FormatedMenuItemType

      // highlightUrls 中是否包含当前的 url（只比较 pathname）
      return highlightUrls.some((item) => {
        return isSameUrlPath(item)
      })
    })

    return (activeIds.value = actives.reduce((total: string[], prev) => {
      const { parentMenu, id } = prev as FormatedMenuItemType
      return parentMenu.concat(total, id)
    }, []))
  }

  return {
    activeIds,
    setActiveIds,
  }
}

const useMenuActiveIndex = () => {
  const activeIndex = ref<string>()

  const update = (val: string) => (activeIndex.value = val)
  return {
    activeIndex,
    update,
  }
}

interface SidebarProps {
  privilege?: Privilege
  setting?: UserSetting
  siteList?: SiteItem[]
}
export default defineComponent<SidebarProps>({
  components: {
    SidebarItem,
    Icon,
    SubMenu,
    BasicMenuItem,
    MenuContent,
  },
  props: {
    privilege: {
      type: Object,
      default: () => ({}),
    },
    setting: {
      type: Object,
      default: () => ({}),
    },
    siteList: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const { menuList, flatMenuObject, fetchSidebarAllUnread, fetchSidebarUnread, updateBadgeStorage } = useMenuList(
      props.privilege as Privilege,
      props.setting as UserSetting,
    )

    let parentOpenKeys = Array.from(menuList.value, ({ id, subMenu }) => subMenu && id).filter(Boolean)
    const menuState = reactive<{ openKeys: string[] }>({ openKeys: [] })

    const { activeIndex, update: updateActiveIndex } = useMenuActiveIndex()
    const { activeIds, setActiveIds } = useActiveIds(flatMenuObject)

    const handleJump = (url: FormatedMenuItemType['url'], urlInfo: FormatedMenuItemType['urlInfo']) => {
      urlInfo ? window.open(url, ...urlInfo) : jumpToUrl(url as string)
    }

    const handleChangeMenu = ({ key }: { key: string }) => {
      const menu = flatMenuObject[key] as FormatedMenuItemType
      menuState.openKeys = menu.parentMenu

      updateActiveIndex(menu.id)
      handleJump(menu.url, menu.urlInfo)
      updateBadgeStorage(menu)
    }

    // 高亮菜单
    useWindowEvent('single-spa:before-routing-event', setActiveIds, {
      immediate: true,
    })

    fetchSidebarAllUnread()
    window.masterEvent.$on('update-sidebar-unread-count', fetchSidebarUnread)

    const handleOpenMenu = (keys: string[]) => {
      const latestOpenKey = keys.find((key) => menuState.openKeys.indexOf(key) === -1) || ''

      if (parentOpenKeys.indexOf(latestOpenKey) === -1) {
        menuState.openKeys = keys
      } else {
        menuState.openKeys = latestOpenKey ? [latestOpenKey] : []
      }
    }

    const handleOpenCRM = () => window.open(HOSTS.CRM_HOST)

    // 发布网站容器是否显示
    const { checkPermission } = useAuth()
    const hasPublishWrap = computed(() => checkPermission(PRIVILEGE.mktFunctionalSiteCustom))

    // 判断当前需要展开的菜单项
    const checkOpenKeys = () => {
      if (menuState.openKeys == null || menuState.openKeys.length === 0) {
        menuState.openKeys = activeIds.value
      }
    }

    checkOpenKeys()

    const hanldeItemClick = ({ key }: { key: string }) => {
      const menu = flatMenuObject[key] as FormatedMenuItemType
      handleJump(menu.url, undefined)
    }

    return {
      menuList,
      activeIds,
      activeIndex,
      flatMenuObject,
      handleOpenMenu,
      handleChangeMenu,
      handleOpenCRM,
      hasPublishWrap,
      ...toRefs(menuState),
      hanldeItemClick,
    }
  },
})
